export default __webpack_public_path__ + "static/media/Time_Rectangle.54648bac.gif";